











































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import Reservation from '@/modules/reservation/model/Reservation';
import PrintReservation from "@/modules/reservation/components/PrintReservation.vue";

/**
 * Celda de la grilla de reservas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {PrintReservation}
})
export default class ReservationCell extends Vue {
    /**
     * Reserva registrada que coincide con la hora
     */
    @Prop({type: Reservation, default: null})
    public reservation: Reservation

    @Prop({type: String, required: true})
    public cellKey: string

    @Prop({type: Boolean, default: false})
    public selected: boolean

    public hovered = false

    /**
     * Retorna el color de la celda según si la hora se encuentra ocupada
     * o no
     */
    public get cellColor (): string {
        if (this.selected) {
            return '#0277BD'
        }

        if (this.hovered && !this.reservation) {
           return '#849c38'
        }

        return this.reservation ?
            this.reservation.event && !!this.reservation.event.color ? this.reservation.event.color : 'red'
            : '#7CB342'
    }
}
